module.exports = __webpack_public_path__ + "static/media/ProximaNova-Black.2d173013.ttf";